export const MENUBAR_DELAY_MS = 50
